module.exports = __webpack_public_path__ + "static/media/logo-txt.f2c84842.svg";